import { Component, OnInit } from '@angular/core';
import { JeevesProductTableComponent } from 'gung-standard-jeeves';
import { AuthService, GungFlowService, LocationConfigService, NavbarConfigService, PriceService } from 'gung-standard';
import { Router } from '@angular/router';
import { first } from 'rxjs';

@Component({
    selector: 'tylo-tylo-product-table',
    templateUrl: './tylo-product-table.component.html',
    styleUrls: ['./tylo-product-table.component.css'],
    standalone: false
})
export class TyloProductTableComponent extends JeevesProductTableComponent implements OnInit {
  isOnlyDisplay = false;

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected router: Router,
    protected locationConfigService: LocationConfigService,
    protected navbarConfigService: NavbarConfigService
  ) {
    super(priceService, gungFlowService, authService, router, locationConfigService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.navbarConfigService
      .showCart()
      .pipe(first())
      .subscribe(showCart => (this.isOnlyDisplay = !showCart));
  }
}
